import {
  DEVICE_PARAM_TYPE,
  GRIPS_DEVICE_ANDROID_APP,
  GRIPS_DEVICE_IOS_APP,
} from '../Checkout/constants';

export type PathIntent =
  | 'checkout/success'
  | 'basket'
  | `p/${string}/${string}`
  | 'a/settings'
  | 'a/orders'
  | `a/order/${string}`
  | 'a/password-reset'
  | 'a/chatbot'
  | 'newsletter/signup';

const getIOSAppUrl = (searchParams: string, intent: PathIntent) =>
  `appaboutyou:/${intent}?${searchParams.replace('?', '')}`;

const getAndroidAppUrl = (searchParams: string, intent: PathIntent) =>
  `intent://m.aboutyou.de/${intent}?${searchParams.replace(
    '?',
    '',
  )}#Intent;package=de.aboutyou.mobile.app;scheme=https;end`;

export const getAppIntentUrlForDevices = ({
  searchParams,
  intent,
  device,
}: {
  searchParams: string;
  intent: PathIntent;
  device: DEVICE_PARAM_TYPE;
}) => {
  let url = '';

  if (device === GRIPS_DEVICE_IOS_APP) {
    url = getIOSAppUrl(searchParams, intent);
  }

  if (device === GRIPS_DEVICE_ANDROID_APP) {
    url = getAndroidAppUrl(searchParams, intent);
  }

  return url;
};
